// Palette
import palette from '../palette'

export default {
  indicator: {
    height: '2px',
    backgroundColor: palette.secondary.main,
  },
}
